import { gql } from '@apollo/client'

export const GET_DISTINCT_LABEL_NAMES_BY_CAMPAIGN = gql`
  query GetDistinctLabelNamesByCampaign($campaignId: Int!) {
    getDistinctLabelNamesByCampaign(campaignId: $campaignId)
  }
`

export interface QueryGetDistinctLabelNamesByCampaignResponse {
  getDistinctLabelNamesByCampaign: string[]
}
